import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { AppState } from '../../store';

export type ProtectedRoutesProps = {
  Component: any;
};

const ProtectedRoutes = ({ Component }: ProtectedRoutesProps) => {
  const accessToken = useSelector((state: AppState) => state.loginReducer.accessToken);
  const isLoggedIn: boolean = !!accessToken;
  const { pathname = '' } = useLocation();

  const StorePathAndRedirect = () => {
    localStorage.setItem('redirect-path', pathname);
    return <Navigate to="/login" />;
  };

  return isLoggedIn ? <Component /> : <StorePathAndRedirect />;
};

export default ProtectedRoutes;
